import { render, staticRenderFns } from "./campaignTemplates.vue?vue&type=template&id=1b3fc420&scoped=true&"
import script from "./campaignTemplates.vue?vue&type=script&lang=js&"
export * from "./campaignTemplates.vue?vue&type=script&lang=js&"
import style0 from "./campaignTemplates.vue?vue&type=style&index=0&id=1b3fc420&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3fc420",
  null
  
)

export default component.exports